import React from 'react';
import { Text, useTPAComponentsContext } from '@wix/wix-ui-tpa';
import { st, classes } from '../Widget.st.css';

interface ShowErrorProps {
  error: any;
}

export const ErrorMessage: React.FC<ShowErrorProps> = ({ error }) => {
  const { mobile } = useTPAComponentsContext();

  if (error) {
    return (
      <div
        data-hook="errorMessage"
        className={st(classes.errorMessage, {
          error: true,
          mobile,
        })}
      >
        <Text className={st(classes.errorResultText)}>{error.message}</Text>
      </div>
    );
  }

  return null;
};
